exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "html, body, .releaseNotes {\n  height: 100%; }\n\n.ReleaseNotes {\n  text-align: left; }\n  .ReleaseNotes .ReleaseNotes-header, .ReleaseNotes .ReleaseNotes-footer {\n    padding: 0 25px; }\n  .ReleaseNotes .header {\n    margin-top: 20px; }\n  .ReleaseNotes .ReleaseNotes-Content {\n    top: 50%;\n    width: 100%;\n    margin-top: 40px; }\n  .ReleaseNotes .upload {\n    margin-top: 10 px; }\n  .ReleaseNotes .required {\n    width: 30%; }\n  .ReleaseNotes .ReleaseNotes-footer {\n    background-color: var(--primary-color);\n    color: var(--text-on-primary-color);\n    bottom: 0;\n    width: 100%;\n    height: 50px;\n    overflow: hidden;\n    text-align: right;\n    position: absolute; }\n    .ReleaseNotes .ReleaseNotes-footer p {\n      padding: 14px 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/Components/Main/ReleaseNotes/ReleaseNotes.scss
// module id = 329
// module chunks = 0